import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

const PrivacyModal = ({ open, onClose }) => {
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="bg-ink border border-white/10 text-on-dark max-w-3xl max-h-[80vh] overflow-y-auto" data-nosnippet>
        <DialogHeader>
          <DialogTitle className="font-sora text-2xl">Adatkezelési Tájékoztató</DialogTitle>
          <p className="text-on-dark/60 text-sm mt-1">Verzió: 2.0 – Hatályba lépés napja: 2025. február 1.</p>
        </DialogHeader>
        <div className="mt-4 space-y-6 text-on-dark/80 text-sm">
          <section>
            <h3 className="font-semibold text-on-dark text-base mb-2">1. Bevezetés és az Adatkezelő azonosítása</h3>
            <p className="mb-3">A Magistro Hungary Kft. és Mergl Attila E.V kisadózó (a továbbiakban: Adatkezelő) elkötelezett a felhasználók és ügyfelek személyes adatainak védelme mellett. Jelen tájékoztató célja, hogy részletes felvilágosítást nyújtson az Adatkezelő által üzemeltetett weboldalon (a továbbiakban: Honlap) végzett adatkezelési műveletekről, összhangban az Európai Parlament és a Tanács (EU) 2016/679 rendeletével (GDPR) és a vonatkozó magyar jogszabályokkal.</p>
            
            <p className="font-medium text-on-dark mb-2">Az Adatkezelők adatai:</p>
            <div className="bg-white/5 rounded-lg p-4 space-y-1 mb-3">
              <p><strong>Cégnév:</strong> Magistro Hungary Kft.</p>
              <p><strong>Székhely:</strong> 1136 Budapest, Tátra utca 5. a/2.</p>
              <p><strong>Adószám:</strong> 27913479-2-41</p>
              <p><strong>Cégjegyzékszám:</strong> 01-09-359567</p>
              <p><strong>Képviselő:</strong> Mergl Attila ügyvezető</p>
              <p><strong>E-mail:</strong> hello@landinglab.hu</p>
            </div>
            <p className="text-center text-on-dark/60 my-2">és</p>
            <div className="bg-white/5 rounded-lg p-4 space-y-1">
              <p><strong>Cégnév:</strong> Mergl Attila E.V kisadózó</p>
              <p><strong>Székhely:</strong> 8060 Mór, Hegyalja utca 11.</p>
              <p><strong>Adószám:</strong> 68751610-1-27</p>
              <p><strong>Képviselő:</strong> Mergl Attila</p>
              <p><strong>E-mail:</strong> hello@landinglab.hu</p>
            </div>
          </section>

          <section>
            <h3 className="font-semibold text-on-dark text-base mb-2">2. Az adatkezelés részletezése (célok és jogalapok)</h3>
            
            <h4 className="font-medium text-on-dark mt-3 mb-1">2.1. Kapcsolatfelvétel és ajánlatkérés</h4>
            <p className="mb-2 text-on-dark/70">Az űrlap kitöltésével Ön közvetlen kapcsolatba lép az Adatkezelővel.</p>
            <ul className="list-disc list-inside space-y-1 ml-2">
              <li><strong>Kezelt adatok:</strong> Név, e-mail cím, vállalkozási profil, üzleti célok, üzenet szövege.</li>
              <li><strong>Adatkezelés célja:</strong> Üzleti kommunikáció, személyre szabott weboldal-vázlat készítése, ajánlattétel.</li>
              <li><strong>Jogalap:</strong> Az érintett önkéntes hozzájárulása [GDPR 6. cikk (1) bek. a) pont].</li>
              <li><strong>Időtartam:</strong> A cél megvalósulásáig, vagy a hozzájárulás visszavonásáig (maximum 2 év).</li>
            </ul>

            <h4 className="font-medium text-on-dark mt-3 mb-1">2.2. Webanalitika és statisztikai mérések</h4>
            <ul className="list-disc list-inside space-y-1 ml-2">
              <li><strong>Kezelt adatok:</strong> IP-cím (anonimizált), földrajzi hely, böngésző típusa, látogatási időtartam, kattintási hőtérkép.</li>
              <li><strong>Adatkezelés célja:</strong> A Honlap teljesítményének mérése, felhasználói élmény javítása.</li>
              <li><strong>Jogalap:</strong> Az Adatkezelő jogos érdeke [GDPR 6. cikk (1) bek. f) pont].</li>
            </ul>

            <h4 className="font-medium text-on-dark mt-3 mb-1">2.3. Marketing, Remarketing és Konverziókövetés</h4>
            <ul className="list-disc list-inside space-y-1 ml-2">
              <li><strong>Kezelt adatok:</strong> Online azonosítók (Cookie ID), korábban megtekintett aloldalak adatai.</li>
              <li><strong>Adatkezelés célja:</strong> Releváns hirdetések megjelenítése külső platformokon (Google, Facebook), hirdetési hatékonyság mérése.</li>
              <li><strong>Jogalap:</strong> Az érintett kifejezett hozzájárulása a süti-kezelő sávban [GDPR 6. cikk (1) bek. a) pont].</li>
            </ul>
          </section>

          <section>
            <h3 className="font-semibold text-on-dark text-base mb-2">3. Adatfeldolgozók és technikai partnerek (harmadik országok)</h3>
            <p className="mb-2 text-on-dark/70">Az Adatkezelő kizárólag olyan partnereket vesz igénybe, amelyek garantálják az adatok biztonságát.</p>
            <div className="space-y-3">
              <div className="bg-white/5 rounded-lg p-3">
                <p className="font-medium">Cloudflare Inc.</p>
                <p className="text-xs text-on-dark/60">Székhely: 101 Townsend St., San Francisco, CA 94107, USA</p>
                <p className="text-xs"><strong>Tevékenység:</strong> Biztonság, Turnstile (spam szűrés), Hosting</p>
                <p className="text-xs"><strong>Megfelelőség:</strong> EU-US Data Privacy Framework</p>
              </div>
              <div className="bg-white/5 rounded-lg p-3">
                <p className="font-medium">Google Ireland Ltd.</p>
                <p className="text-xs text-on-dark/60">Cím: Gordon House, Barrow Street, Dublin 4, Írország</p>
                <p className="text-xs"><strong>Tevékenység:</strong> Analytics 4, Ads, Remarketing</p>
                <p className="text-xs"><strong>Megfelelőség:</strong> Google Privacy Policy</p>
              </div>
              <div className="bg-white/5 rounded-lg p-3">
                <p className="font-medium">Meta Platforms Ireland</p>
                <p className="text-xs text-on-dark/60">4 Grand Canal Square, Grand Canal Harbour, Dublin 2, Írország</p>
                <p className="text-xs"><strong>Tevékenység:</strong> Facebook Pixel, Instagram Ads</p>
                <p className="text-xs"><strong>Megfelelőség:</strong> Meta Privacy Policy</p>
              </div>
              <div className="bg-white/5 rounded-lg p-3">
                <p className="font-medium">Proton AG (Svájc)</p>
                <p className="text-xs text-on-dark/60">Route de la Galaise 32, 1228 Plan-les-Ouates, Svájc</p>
                <p className="text-xs"><strong>Tevékenység:</strong> Levelezés</p>
                <p className="text-xs"><strong>Megfelelőség:</strong> Svájci adatvédelmi törvény (FADP)</p>
              </div>
            </div>
          </section>

          <section>
            <h3 className="font-semibold text-on-dark text-base mb-2">4. Cookie (Süti) kezelési irányelv</h3>
            <p className="mb-2 text-on-dark/70">A Honlap sütiket használ a működéshez és a marketing folyamatokhoz.</p>
            
            <h4 className="font-medium text-on-dark mt-3 mb-1">4.1. Sütik típusai</h4>
            <ul className="list-decimal list-inside space-y-1 ml-2">
              <li><strong>Szükséges sütik:</strong> Ezek nélkül az oldal nem működik (pl. biztonsági beállítások, spam szűrés - Cloudflare Turnstile).</li>
              <li><strong>Statisztikai sütik (Google Analytics 4):</strong> Segítenek látni, hányan és hogyan használják az oldalt. Ezek az adatok anonimizáltak.</li>
              <li><strong>Marketing sütik (Google Ads & Facebook Pixel):</strong> Segítségükkel tudjuk Önt később "megkeresni" hirdetésekkel a közösségi médiában vagy a Google hálózatában.</li>
            </ul>

            <h4 className="font-medium text-on-dark mt-3 mb-1">4.2. Hogyan tilthatja le a sütiket?</h4>
            <p>Ön bármikor módosíthatja böngészője beállításait a sütik elutasítására. Emellett használhatja a platform-specifikus leiratkozási linkeket (Google hirdetési beállítások, Facebook hirdetési beállítások).</p>
          </section>

          <section>
            <h3 className="font-semibold text-on-dark text-base mb-2">5. Az érintettek jogai és érvényesítésük</h3>
            <p className="mb-2 text-on-dark/70">Ön a GDPR értelmében az alábbi jogokkal rendelkezik:</p>
            <ul className="list-decimal list-inside space-y-1 ml-2">
              <li><strong>Tájékoztatáshoz való jog:</strong> Bármikor kérheti adatainak kezeléséről szóló információkat.</li>
              <li><strong>Helyesbítéshez való jog:</strong> Kérheti hibás adatai javítását.</li>
              <li><strong>Törléshez való jog ("Az elfeledtetéshez való jog"):</strong> Kérheti adatai törlését, ha a jogalap megszűnt.</li>
              <li><strong>Adathordozhatósághoz való jog:</strong> Kérheti adatait géppel olvasható formátumban.</li>
              <li><strong>Tiltakozáshoz való jog:</strong> Tiltakozhat a jogos érdeken alapuló adatkezelés ellen.</li>
            </ul>
            <p className="mt-2"><strong>Kérelmek benyújtása:</strong> hello@landinglab.hu</p>
          </section>

          <section>
            <h3 className="font-semibold text-on-dark text-base mb-2">6. Jogorvoslati lehetőségek</h3>
            <p className="mb-2">Amennyiben úgy véli, hogy az Adatkezelő megsértette a jogait, kérjük, vegye fel velünk a kapcsolatot a panasz békés rendezése érdekében.</p>
            <p className="mb-2">Jogosult továbbá panasszal élni a felügyeleti hatóságnál:</p>
            <div className="bg-white/5 rounded-lg p-4">
              <p className="font-medium">Nemzeti Adatvédelmi és Információszabadság Hatóság (NAIH)</p>
              <p>Cím: 1055 Budapest, Falk Miksa utca 9-11.</p>
              <p>Honlap: www.naih.hu</p>
              <p>E-mail: ugyfelszolgalat@naih.hu</p>
            </div>
          </section>

          <section>
            <h3 className="font-semibold text-on-dark text-base mb-2">7. Adatbiztonsági intézkedések</h3>
            <p className="mb-2 text-on-dark/70">Az Adatkezelő az adatok védelme érdekében az alábbiakat alkalmazza:</p>
            <ul className="list-disc list-inside space-y-1 ml-2">
              <li>SSL/TLS titkosítás a teljes weboldalon (HTTPS).</li>
              <li>Protonmail végponti titkosítású levelezés.</li>
              <li>Cloudflare Turnstile mesterséges intelligencia alapú bot-védelem (hagyományos captcha helyett, adatvédelmi szempontból kedvezőbb).</li>
              <li>Rendszeres biztonsági mentések és hozzáférés-védelem.</li>
            </ul>
          </section>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default PrivacyModal;
